import { HttpMethod, PagingQuery } from "~/extensions/api";
export class FindNyukyoshaCommand extends PagingQuery {
    constructor(model) {
        super(HttpMethod.Post, "nyukyosha/admin/find");
        this.nyukyokeiyakuNo = model.nyukyokeiyakuNo ?? null;
        this.userCd = model.userCd ?? null;
        this.userName = model.userName;
        this.nyukyoshaName = model.nyukyoshaName;
        this.jokyoKb = model.jokyoKb?.value ?? null;
        this.buknCd = model.buknCd ?? null;
        this.buknName = model.buknName;
        this.unconfirmedFlag = model.unconfirmedFlag;
    }
    nyukyokeiyakuNo = null;
    userCd = null;
    userName = "";
    nyukyoshaName = "";
    jokyoKb = null;
    buknCd = null;
    buknName = "";
    unconfirmedFlag = false;
}
